export const DateRangeMap = {
  week: '近7天',
  month: '近30天',
  three_months: '近90天'
}
